import * as React from "react";
import type { SVGProps } from "react";
const SvgEnsureSecurity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M31.557.08a.865.865 0 0 1 .365-.08h.156c.126 0 .25.028.365.08l23.663 11.03c.264.123.448.37.49.658l-.855.125.855-.125v.006l.003.013.007.05a30.294 30.294 0 0 1 .113.913c.07.628.162 1.538.245 2.675.166 2.273.299 5.457.166 9.107-.264 7.267-1.584 16.48-5.878 24.007l-.002.006c-.034.069-.11.222-.234.447-.164.3-.411.728-.75 1.255a30.32 30.32 0 0 1-3.2 4.105c-2.96 3.21-7.66 7.048-14.638 9.596a.864.864 0 0 1-.297.052h-.262a.866.866 0 0 1-.297-.053c-6.978-2.55-11.678-6.387-14.638-9.597a30.329 30.329 0 0 1-3.2-4.104 20.766 20.766 0 0 1-.75-1.254c-.124-.225-.2-.378-.234-.447l-.003-.006C8.454 41.012 7.134 31.8 6.87 24.532c-.133-3.65 0-6.834.166-9.107.083-1.137.174-2.047.245-2.675a42.829 42.829 0 0 1 .113-.913l.007-.05.002-.013v-.005l.856.124-.856-.124a.866.866 0 0 1 .49-.66L31.558.082ZM9.055 12.478a66.614 66.614 0 0 0-.294 3.075 82.66 82.66 0 0 0-.163 8.917c.26 7.169 1.565 16.064 5.666 23.239.085.148.154.304.236.453.146.267.373.66.688 1.15.63.98 1.615 2.346 3.018 3.867 2.78 3.017 7.207 6.644 13.794 9.084 6.587-2.438 11.013-6.065 13.794-9.082a28.597 28.597 0 0 0 3.018-3.869c.315-.49.541-.883.687-1.15.082-.15.159-.301.237-.453m0 0c4.1-7.175 5.405-16.07 5.666-23.24.13-3.573 0-6.692-.163-8.917a66.717 66.717 0 0 0-.294-3.074L32 1.782 9.212 12.403l-.157.074"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M32 13.367c.545 0 .988.442.988.988v7.53a.988.988 0 1 1-1.977 0v-7.53c0-.546.443-.988.988-.988ZM32 38.694c.545 0 .988.442.988.988v7.53a.988.988 0 0 1-1.977 0v-7.53c0-.546.443-.989.988-.989ZM14.583 30.784c0-.546.442-.988.988-.988h7.346a.988.988 0 0 1 0 1.976h-7.346a.988.988 0 0 1-.988-.988ZM39.91 30.784c0-.546.442-.988.988-.988h7.526a.988.988 0 1 1 0 1.976h-7.526a.988.988 0 0 1-.988-.988ZM26.277 36.507a.988.988 0 0 1 0 1.397L21.081 43.1a.988.988 0 0 1-1.397-1.398l5.196-5.195a.988.988 0 0 1 1.397 0ZM44.325 18.477a.988.988 0 0 1-.018 1.397l-5.643 5.498a.988.988 0 0 1-1.38-1.416l5.644-5.497a.988.988 0 0 1 1.397.018ZM37.072 35.927a.988.988 0 0 1 1.397-.008l5.843 5.78a.988.988 0 1 1-1.39 1.405l-5.843-5.78a.988.988 0 0 1-.007-1.397ZM19.686 18.475a.988.988 0 0 1 1.398-.005l5.634 5.595a.988.988 0 0 1-1.393 1.402l-5.634-5.595a.988.988 0 0 1-.005-1.397Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M41.763 30.828a9.845 9.845 0 0 1-9.846 9.846 9.845 9.845 0 0 1-9.847-9.846 9.845 9.845 0 0 1 9.847-9.847 9.845 9.845 0 0 1 9.846 9.847Zm-7.146-2.277a2.603 2.603 0 1 0-3.63 2.389l-.33 4.67h2.71l-.331-4.67a2.606 2.606 0 0 0 1.576-2.39h.005Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M31.917 21.846a8.98 8.98 0 0 0-8.982 8.982 8.98 8.98 0 0 0 8.982 8.982 8.98 8.98 0 0 0 8.982-8.982 8.98 8.98 0 0 0-8.982-8.982Zm-10.71 8.982c0-5.917 4.794-10.712 10.71-10.712 5.917 0 10.712 4.795 10.712 10.712 0 5.916-4.795 10.71-10.712 10.71-5.916 0-10.71-4.794-10.71-10.71Zm7.34-2.277a3.467 3.467 0 1 1 6.935 0 .887.887 0 0 1-.007.106 3.463 3.463 0 0 1-1.537 2.771l.291 4.12a.864.864 0 0 1-.862.926h-2.71a.865.865 0 0 1-.862-.925l.291-4.119a3.463 3.463 0 0 1-1.539-2.88Zm5.204-.076a1.738 1.738 0 1 0-2.424 1.67c.34.144.55.488.524.856l-.266 3.744h.854l-.265-3.744a.865.865 0 0 1 .52-.855 1.741 1.741 0 0 0 1.054-1.595c0-.026 0-.05.003-.076Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M32 15.187a1.917 1.917 0 1 0-.001-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.985 13.27c0-1.115.9-2.015 2.016-2.015a2.016 2.016 0 1 1-2.016 2.016ZM32 11.452a1.816 1.816 0 0 0-1.818 1.818A1.819 1.819 0 1 0 32 11.452Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M32 50.774a1.917 1.917 0 1 0-.001-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.985 48.857c0-1.115.9-2.016 2.016-2.016a2.016 2.016 0 1 1-2.016 2.016ZM32 47.039a1.816 1.816 0 0 0-1.818 1.818A1.819 1.819 0 1 0 32 47.039Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M32 15.187a1.917 1.917 0 1 0-.001-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.985 13.27c0-1.115.9-2.015 2.016-2.015a2.016 2.016 0 1 1-2.016 2.016ZM32 11.452a1.816 1.816 0 0 0-1.818 1.818A1.819 1.819 0 1 0 32 11.452Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M32 50.774a1.917 1.917 0 1 0-.001-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.985 48.857c0-1.115.9-2.016 2.016-2.016a2.016 2.016 0 1 1-2.016 2.016ZM32 47.039a1.816 1.816 0 0 0-1.818 1.818A1.819 1.819 0 1 0 32 47.039Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M19.419 20.402a1.917 1.917 0 1 0-.002-3.835 1.917 1.917 0 0 0 .002 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M17.404 18.485c0-1.115.9-2.015 2.015-2.015a2.016 2.016 0 1 1-2.016 2.016Zm2.015-1.818a1.816 1.816 0 0 0-1.818 1.818 1.818 1.818 0 1 0 1.818-1.818Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M44.58 45.563a1.917 1.917 0 1 0 0-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M42.565 43.647c0-1.116.9-2.016 2.015-2.016a2.016 2.016 0 1 1-2.015 2.016Zm2.015-1.818a1.815 1.815 0 0 0-1.818 1.818 1.819 1.819 0 1 0 1.818-1.818Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M14.209 32.73a1.917 1.917 0 1 0-.002-3.835 1.917 1.917 0 0 0 .002 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M12.193 30.813c0-1.115.9-2.016 2.016-2.016a2.016 2.016 0 1 1-2.015 2.016Zm2.016-1.818a1.815 1.815 0 0 0-1.818 1.818 1.819 1.819 0 1 0 1.818-1.818Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M49.79 32.73a1.917 1.917 0 1 0 0-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M47.775 30.813c0-1.115.9-2.016 2.016-2.016a2.016 2.016 0 1 1-2.016 2.016Zm2.016-1.818a1.815 1.815 0 0 0-1.819 1.818 1.819 1.819 0 1 0 1.818-1.818Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M14.209 32.73a1.917 1.917 0 1 0-.002-3.835 1.917 1.917 0 0 0 .002 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M12.193 30.813c0-1.115.9-2.016 2.016-2.016a2.016 2.016 0 1 1-2.015 2.016Zm2.016-1.818a1.815 1.815 0 0 0-1.818 1.818 1.819 1.819 0 1 0 1.818-1.818Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M49.79 32.73a1.917 1.917 0 1 0 0-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M47.775 30.813c0-1.115.9-2.016 2.016-2.016a2.016 2.016 0 1 1-2.016 2.016Zm2.016-1.818a1.815 1.815 0 0 0-1.819 1.818 1.819 1.819 0 1 0 1.818-1.818Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M19.419 45.257a1.917 1.917 0 1 0-.001-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M17.404 43.34c0-1.115.9-2.016 2.015-2.016a2.016 2.016 0 1 1-2.016 2.016Zm2.015-1.818a1.815 1.815 0 0 0-1.818 1.818 1.819 1.819 0 1 0 1.818-1.818Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M44.58 20.096a1.917 1.917 0 1 0 0-3.835 1.917 1.917 0 0 0 0 3.835Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M42.565 18.179c0-1.115.9-2.016 2.015-2.016a2.016 2.016 0 1 1-2.015 2.016Zm2.015-1.818a1.815 1.815 0 0 0-1.818 1.818 1.819 1.819 0 1 0 1.818-1.818Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEnsureSecurity;
